import { useState } from "react";
import Box from "@mui/material/Box";
import { useFormContext } from "react-hook-form";
import { useDispatchApp } from "../../../../lib/redux";
import { getPathDatabaseByRole } from "../../../../actions/auth";
import TextField from "../../../Form/TextField";
import UploadFileButton from "../../../Buttons/UploadFileButton";
import DocumentFilesList from "../../../Form/DocumentFilesList";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { FILE_FORMATS } from "../../../../utils/constants";
import { WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN } from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";

const StepInstructions = ({ disabled = false }) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const { userID } = dispatch(getPathDatabaseByRole());
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const attachmentsFiles = watch("attachmentsFiles") || [];
  const fileNamesMapping = watch("fileNamesMapping") || {};
  const [pendingFilesCount, setPendingFilesCount] = useState(0);

  const onFileUpload = (newUrls) => {
    const urlsArray = Array.isArray(newUrls) ? newUrls : [newUrls];
    const nextMapping = { ...fileNamesMapping };

    if (window.pendingFiles && window.pendingFiles.length > 0) {
      urlsArray.forEach((url) => {
        if (window.pendingFiles.length > 0) {
          const file = window.pendingFiles.shift();
          nextMapping[url] = file.name;
        }
      });
    }

    const nextFiles = [...attachmentsFiles, ...urlsArray];
    setPendingFilesCount((prev) => Math.max(0, prev - urlsArray.length));
    setValue("fileNamesMapping", nextMapping);
    setValue("attachmentsFiles", nextFiles);
  };

  const onRemoveFile = (index) => {
    const removedFileUrl = attachmentsFiles[index];
    const nextFiles = attachmentsFiles.filter(
      (_, fileIndex) => fileIndex !== index
    );
    const nextMapping = { ...fileNamesMapping };
    delete nextMapping[removedFileUrl];
    setValue("attachmentsFiles", nextFiles);
    setValue("fileNamesMapping", nextMapping);
  };

  const onFileSelect = (files) => {
    window.pendingFiles = Array.from(files);
    setPendingFilesCount(files.length);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <UploadFileButton
          disableVerificationMedia={true}
          id="upload-documents-create-campaign"
          value={false}
          name="attachedDocuments"
          acceptedFormats={FILE_FORMATS}
          multiple={true}
          pathStorage={`adsCampaigns/${userID}/documents/`}
          onChange={onFileUpload}
          onFileSelect={onFileSelect}
          type="icon"
          disabled={disabled}
          icon={<AttachFileIcon sx={{ fontSize: "18px" }} />}
          sx={{
            minWidth: "auto !important",
            width: "38px !important",
            height: "38px !important",
            px: "10px !important",
          }}
        />
      </Box>
      <TextField
        multiline={true}
        maxRows={4}
        minRows={4}
        name="context"
        placeholder={t(WRITE_INSTRUCTIONS_TO_CREATE_YOUR_CAMPAIGN)}
        variant="filled"
        fullWidth
        control={control}
        errors={errors}
        disabled={disabled}
        rules={{ required: false }}
      />
      <DocumentFilesList
        files={attachmentsFiles}
        fileNamesMapping={fileNamesMapping}
        onRemoveFile={onRemoveFile}
        disabled={disabled}
        pendingFilesCount={pendingFilesCount}
      />
    </Box>
  );
};

export default StepInstructions;
